import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import ChatComp from '../../../components/patientApp/patientChat/chat/chat';

const Chat = () => {
    return <Background>
        <ChatComp />
    </Background>
}
export default Chat;